import { PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { ParametrosCard } from './components/ParametrosCard'
import {
  getParametrosLogin,
  getParametrosPdfEncryption,
  getParametrosSenha,
  getParametrosSessao,
  updateParametrosLogin,
  updateParametrosPdfEncryption,
  updateParametrosSenha,
  updateParametrosSessao,
} from './core/_requests'

const ParametrosPage = () => {
  const { t } = useT()

  return (
    <>
      <PageTitle description={t('parametros.descricao')}>{t('menu.nav.parametros')}</PageTitle>
      <ParametrosCard
        id='senha'
        titulo={t('parametros.senha.titulo')}
        descricao={t('parametros.senha.descricao')}
        buscar={getParametrosSenha}
        salvar={updateParametrosSenha}
        campos={[
          {
            name: 'dias',
            tipo: 'numero',
            min: 0,
            max: 180,
            label: t('parametros.senha.dias'),
            infoText: t('parametros.senha.dias_info'),
          },
          {
            name: 'historico',
            tipo: 'numero',
            min: 2,
            max: 10,
            label: t('parametros.senha.historico'),
            infoText: t('parametros.senha.historico_info'),
          },
        ]}
      />
      <ParametrosCard
        id='login'
        titulo={t('parametros.login.titulo')}
        descricao={t('parametros.login.descricao')}
        buscar={getParametrosLogin}
        salvar={updateParametrosLogin}
        campos={[
          {
            name: 'maxTentativas',
            tipo: 'numero',
            min: 0,
            max: 10,
            label: t('parametros.login.max_tentativas'),
            infoText: t('parametros.login.max_tentativas_info'),
          },
          {
            name: 'tempoBloqueio',
            tipo: 'numero',
            min: 1,
            max: 60,
            label: t('parametros.login.tempo_bloqueio'),
            infoText: t('parametros.login.tempo_bloqueio_info'),
          },
        ]}
      />
      <ParametrosCard
        id='sessao'
        titulo={t('parametros.sessao.titulo')}
        descricao={t('parametros.sessao.descricao')}
        buscar={getParametrosSessao}
        salvar={updateParametrosSessao}
        campos={[
          {
            name: 'tempoInatividade',
            tipo: 'numero',
            min: 0,
            max: 180,
            label: t('parametros.sessao.tempo_inatividade'),
            infoText: t('parametros.sessao.tempo_inatividade_info'),
          },
        ]}
      />
      <ParametrosCard
        id='pdf-encryption'
        titulo={t('parametros.pdf.titulo')}
        descricao={t('parametros.pdf.descricao')}
        buscar={getParametrosPdfEncryption}
        salvar={updateParametrosPdfEncryption}
        campos={[
          {
            name: 'habilitado',
            tipo: 'booleano',
            label: t('parametros.pdf.habilitado'),
            infoText: t('parametros.pdf.habilitado_info'),
          },
        ]}
      />
    </>
  )
}

export default ParametrosPage
